export function htmlStrip(html: string) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function hasContent(html: string): boolean {
  if (!html) {
    return false;
  }

  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;

  // Check for text content
  const textContent = (tmp.textContent || tmp.innerText || "").trim();
  if (textContent) {
    return true;
  }

  // Check for images
  const images = tmp.querySelectorAll("img");
  if (images.length > 0) {
    return true;
  }

  return false;
}

export function htmlTrim(html: string): string {
  let isEmpty = true;

  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;

  while (tmp.firstChild && isEmpty) {
    const child = tmp.firstChild;
    if (child instanceof HTMLElement) {
      if ((child.textContent || child.innerText || "").trim() === "") {
        tmp.removeChild(tmp.firstChild);
      } else {
        isEmpty = false;
      }
    } else {
      tmp.removeChild(tmp.firstChild);
    }
  }

  isEmpty = true;

  while (tmp.lastChild && isEmpty) {
    const child = tmp.lastChild;

    if (child instanceof HTMLElement) {
      if ((child.textContent || child.innerText || "").trim() === "") {
        tmp.removeChild(tmp.lastChild);
      } else {
        isEmpty = false;
      }
    } else {
      tmp.removeChild(tmp.lastChild);
    }
  }

  return tmp.innerHTML;
}

export function treeTraversal(
  html: string,
  calledFunction: (element: HTMLElement) => void
) {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;

  const parentStack: number[] = [];
  let curPos = 0;

  // A non-recursive tree traversal
  do {
    // 1. Call a function
    if (tmp instanceof HTMLElement) {
      calledFunction(tmp);
    }

    // 2. Check if tmp has a child
    if (tmp.childNodes !== undefined && tmp.childNodes.length > 0) {
      // 2a. If it has, add current position to stack and repeat
      parentStack.push(curPos);
      curPos = 0;
      tmp = tmp.childNodes[curPos] as HTMLElement;
    } else {
      // 2b. If it hasn't, check if it's not the last child of parent
      if (
        tmp.parentElement !== null &&
        tmp.parentElement.childNodes !== undefined &&
        tmp.parentElement.childNodes.length > curPos + 1
      ) {
        // 2ba. If not last, get another child
        curPos++;
        tmp = tmp.parentElement.childNodes[curPos] as HTMLElement;
      } else {
        // 2bb. If last, remove parent from stack
        let isCheck = false;
        while (!isCheck && parentStack.length > 0) {
          const poppedValue = parentStack.pop();
          const newPos = poppedValue ? poppedValue + 1 : 0;
          tmp = tmp.parentElement as HTMLElement;

          if (
            tmp.parentElement &&
            tmp.parentElement.childNodes.length > newPos
          ) {
            curPos = newPos;
            tmp = tmp.parentElement.childNodes[curPos] as HTMLElement;
            isCheck = true;
          }
        }
      }
    }
  } while (parentStack.length > 0);

  return tmp instanceof HTMLElement ? tmp.innerHTML : "";
}

